<template>
  <ul>
    <li
      v-for="(item, index) in getMediaLibrary"
      :key="index"
    >
      <div class="media-library-container">
        <div class="media-library-img">
          <pdf-preview-trigger
            v-if="item.Extension === 'document'"
            :url="item.TargetUrl"
            :share-url="item.ShareUrl"
          >
            <img
              class="download-link"
              :content-download-url="item.TargetUrl"
              content-download-type="pdf"
              :src="item.ThumbnailUrl"
            >
          </pdf-preview-trigger>
          <a
            v-if="item.Extension === 'video'"
            class="download-link"
            :content-download-url="item.TargetUrl"
            content-download-type="video"
            @click="onClickVideo(item.TargetUrl, item.ShareUrl)"
          >
            <img :src="item.ThumbnailUrl">
          </a>
          <a
            v-if="item.Extension === 'image'"
            class="download-link"
            :content-download-url="item.TargetUrl"
            content-download-type="image"
            @click="onClickImage(item.TargetUrl)"
          >
            <img :src="item.ThumbnailUrl">
          </a>
          <a
            v-if="item.Extension === 'page'"
            class="download-link"
            :content-download-url="item.TargetUrl"
            content-download-type="page"
            :href="item.TargetUrl"
          >
            <img :src="item.ThumbnailUrl">
          </a>
        </div>
        <div class="media-library-description">
          <h2>{{ item.Title }}</h2>
          <p>{{ item.CategoryDescription }}  {{ item.Extension.length ? (' | ' + item.ExtensionDisplay ) : '' }}</p>
        </div>
      </div>
    </li>
  </ul>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'media-library-item',
  computed: {
    ...mapGetters({
      getMediaLibrary: 'getMediaLibrary',
      getCategoryId: 'getCategoryId',
      getTypeFiltro: 'getTypeFiltro'
    })
  },
  methods: {
    onClickImage(target) {
      this.$modal.show('preview-modal', { url: target, type: 'image' })
    },
    onClickVideo(target, videoShareUrl) {
      this.$modal.show('preview-modal', {
        videos: { first: target },
        shareUrl: videoShareUrl,
        type: 'video'
      })
    }
  }
}
</script>
